import * as React from "react";
import * as classnames from "classnames";
import { compose, withProps, defaultProps, setDisplayName, withState, withHandlers } from "recompose";
import { find, uniq, get, includes, compact, xor } from "lodash-es";
import Input from "../Input";
import Icon from "../Icon";
var enhance = compose(defaultProps({
    items: [],
    isMultiple: false,
    selectedText: " selected",
    emptyPlaceholder: 'No items found'
}), withState("searchString", "setSearchString", ""), 
// modify items prop by searchString
withProps(function (props) { return ({
    activeItem: find(props.items, { value: props.value }),
    items: props.items.filter(function (item) {
        return (typeof item.label === "string" &&
            (includes(item.label.toLocaleLowerCase(), props.searchString.toLocaleLowerCase()) || includes((item.group || '').toLocaleLowerCase(), props.searchString.toLocaleLowerCase())));
    })
}); }), withProps(function (props) { return ({
    groups: props.groups || uniq(props.items.map(function (item) { return item.group; })) || []
}); }), withState("activeGroup", "setActiveGroup", function (props) {
    return get(props.activeItem, "group", props.groups[0]);
}), withProps(function (props) { return ({
    groupedItems: props.items.filter(function (item) {
        return item.group === props.activeGroup;
    }),
}); }), withHandlers({
    onItemClick: function (props) { return function (_a) {
        var value = _a.value;
        return function () {
            if (props.isMultiple) {
                props.onChange(uniq(compact(xor(props.value, [value]))));
            }
            else {
                props.onChange(value);
            }
        };
    }; }
}), setDisplayName("GroupedInline"));
var GroupedInline = enhance(function (props) {
    return (React.createElement("div", { className: "sui-grouped-inline__wrap" },
        React.createElement("div", { className: "sui-grouped-inline__search" },
            React.createElement(Input, { value: props.searchString, onChange: function (e) { return props.setSearchString(e.target.value); }, stretched: true },
                React.createElement(Icon, null, "s"))),
        React.createElement("div", { style: props.groupsItemsStyle, className: "sui-grouped-inline__groups-items" },
            props.groups.length > 0 &&
                React.createElement("div", { className: "sui-advanced-select__groups", style: props.groupsStyle }, props.groups.map(function (group) { return (React.createElement("div", { key: (props.activeItem &&
                        props.activeItem.value) + "_" + group, onClick: function () {
                        props.setActiveGroup(group);
                    }, className: classnames("sui-advanced-select__item", {
                        "sui-advanced-select__item--active": props.activeGroup === group
                    }) }, group)); })),
            props.groupedItems.length > 0 &&
                React.createElement("div", { className: "sui-advanced-select__items" }, props.groupedItems.map(function (item) { return (React.createElement("div", { key: (props.activeItem && props.activeItem.value) + "_" + item.value, onClick: props.onItemClick({
                        value: item.value
                    }), className: classnames("sui-advanced-select__item", {
                        "sui-advanced-select__item--active": props.value === item.value ||
                            (Array.isArray(props.value) &&
                                includes(props.value, item.value))
                    }) }, item.label)); })),
            props.groups.length == 0 &&
                React.createElement("div", { className: 'sui-advanced-select__empty' }, props.emptyPlaceholder))));
});
export default GroupedInline;
//# sourceMappingURL=GroupedInline.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/GroupedInline/GroupedInline.js
// module id = 1960
// module chunks = 17